<template>
  <div id="assets" class="bottom-corner-background-img main-component-container">
      <v-card-title class="component-title">
          <img alt="AboutTitle" v-bind:src="require('@/assets/Assets.png')" class="component-title-image">
      </v-card-title>
      <div class="component-content">
        <div class="row">
          <div class="component-locale-text">
                <p v-for="(text, index) in $i18n.messages[$i18n.locale].assets.content" :key="index">{{ text }}</p>
                <!--p v-html="$i18n.messages[$i18n.locale].assets.info"></p-->
                <p>(Unity store site TBA.)</p>
          </div>
          <div class = "row flex-item-space-between">
          <div ><img alt="Ilustration" v-bind:src="require('@/assets/Lucia.png')" class=" content-image"></div>
        <!--  <div>
            <img alt="Ilustration" v-bind:src="require('@/assets/Vero.png')" class="image content-image">
          </div>-->
          </div>
        </div>
      </div>

  </div>
</template>


<script>

export default {
    name:'Assets'
}
</script>


<style scoped>

.bottom-corner-background-img{
  background-image: url('~@/assets/mgcircle.png');
}

</style>
